import { loadScript } from '@revolugo/elements-core-next'

// eslint-disable-next-line no-console
loadScript().catch((error: unknown) => console.error(error))
